// src/components/clinica/IconoEspecialidad.js
// Icono de línea para cada tipo de clínica (catálogo: shared/especialidades/catalogo.js → icono)
import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import MedicalServicesOutlined from '@mui/icons-material/MedicalServicesOutlined';
import AccessibilityNewOutlined from '@mui/icons-material/AccessibilityNewOutlined';
import PsychologyOutlined from '@mui/icons-material/PsychologyOutlined';
import RestaurantOutlined from '@mui/icons-material/RestaurantOutlined';
import DirectionsWalkOutlined from '@mui/icons-material/DirectionsWalkOutlined';
import FaceRetouchingNaturalOutlined from '@mui/icons-material/FaceRetouchingNaturalOutlined';
import LocalHospitalOutlined from '@mui/icons-material/LocalHospitalOutlined';

// MUI no tiene diente: lo dibujamos con el mismo trazo que el resto de iconos de línea
function DienteOutlined(props) {
    return (
        <SvgIcon {...props}>
            <path
                fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"
                d="M7.5 3.5c-2.3 0-4 1.8-4 4.2 0 2.2.9 3.7 1.5 5.7.5 1.9.7 4.3 1.8 6.2.4.7 1.3.7 1.7 0 .7-1.4 1-3.8 3.5-3.8s2.8 2.4 3.5 3.8c.4.7 1.3.7 1.7 0 1.1-1.9 1.3-4.3 1.8-6.2.6-2 1.5-3.5 1.5-5.7 0-2.4-1.7-4.2-4-4.2-1.9 0-2.8 1-4.5 1s-2.6-1-4.5-1z"
            />
        </SvgIcon>
    );
}

const ICONOS = {
    medicina: MedicalServicesOutlined,
    fisioterapia: AccessibilityNewOutlined,
    psicologia: PsychologyOutlined,
    odontologia: DienteOutlined,
    nutricion: RestaurantOutlined,
    podologia: DirectionsWalkOutlined,
    estetica: FaceRetouchingNaturalOutlined
};

export default function IconoEspecialidad({ icono, ...props }) {
    const Icono = ICONOS[icono] || LocalHospitalOutlined;
    return <Icono aria-hidden="true" {...props} />;
}
